import React, {useEffect} from "react";
import loadingAnimation from "../assets/images/content/loadingAnimation.svg";

interface LoaderProps {
    visible: boolean;
    color?: string;
    height?: number;
    width?: number;
    text?: string; // Optional text parameter
    backdrop?: boolean; // Dim the page and block all interaction underneath
}

const Loader: React.FC<LoaderProps> = ({
                                           visible,
                                           height = 100,
                                           width = 100,
                                           text,
                                           backdrop = false,
                                       }) => {
    const blocking = visible && backdrop;

    // The overlay already stops mouse clicks; also stop keyboard users from
    // tabbing to, or activating, controls underneath while it is shown.
    useEffect(() => {
        if (!blocking) return;
        (document.activeElement as HTMLElement | null)?.blur();
        const blockKeys = (e: KeyboardEvent) => {
            if (e.key === "Tab" || e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                e.stopPropagation();
            }
        };
        document.addEventListener("keydown", blockKeys, true);
        return () => document.removeEventListener("keydown", blockKeys, true);
    }, [blocking]);

    if (!visible) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            aria-busy="true"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 9999,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                ...(backdrop && {
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    cursor: "wait",
                }),
            }}
        >
            <img
                src={loadingAnimation}
                alt="Loading..."
                title="Loading..."
                style={{
                    height: `${height}px`,
                    width: `${width}px`,
                    objectFit: "contain",
                }}
            />
            {text && (
                <div
                    style={{
                        marginTop: 20,
                        color: "#000000",
                        fontSize: "1.2rem",
                        textAlign: "center",
                    }}
                >
                    {text}
                </div>
            )}
        </div>
    );
};


export default Loader;
